//请自行添加语言资源
const coalPlan = {
  plantName:"基地",
  purchOrderNo:'采购订单号',
  planNo:"计划单号",
  planStatusName:'计划状态',
  controlWeight:'订单控量',
  expirationTime:'执行到期日期',
  closeReason: '关闭原因',
  createTime: '创建时间',
  contractTotalWeight: '合同总重量',
  contractWeightUnit: '合同总重量单位',
  msg:{
  }
};
export default coalPlan



// WEBPACK FOOTER //
// ./src/page/bd/coal/coalPlan/lang/coalPlan.zh.js